module.exports = __webpack_public_path__ + "media/images/appIcon-5083e23c3372ae389cdb7ad37b6b600c.png";